import React, { useEffect, useState } from 'react';
import { Card, Splitter } from 'antd';
import { ICustomSplitterProps } from 'src/models/Splitter';

const CustomSplitter: React.FC<Readonly<ICustomSplitterProps>> = ({
  firstPanelContent,
  secondPanelContent,
  isSecondPanelVisible,
  setIsSecondPanelVisible,
}) => {
  const [sizes, setSizes] = useState<[number, number]>([100, 0]);

  useEffect(() => {
    if (isSecondPanelVisible && sizes[1] === 0) {
      setSizes([40, 60]);
    }
  }, [isSecondPanelVisible]);

  const handleResize = (newSizes: number[]) => {
    if (sizes[1] === 0 && newSizes[1] > 0) {
      setSizes([40, 60]);
      setIsSecondPanelVisible(true);
    } else if (sizes[0] === 0 && newSizes[0] > 0) {
      setSizes([40, 60]);
      setIsSecondPanelVisible(true);
    } else if (sizes[1] !== 0 && newSizes[1] === 0) {
      setIsSecondPanelVisible(false);
      setSizes([100, 0]);
    } else {
      setSizes([newSizes[0], newSizes[1]]);
    }
  };

  return (
    <Card size="small">
      <Splitter
        style={{ height: 'calc(100vh - 140px)' }}
        onResize={handleResize}
      >
        <Splitter.Panel min="30%" collapsible size={sizes[0]}>
          {firstPanelContent?.()}
        </Splitter.Panel>
        <Splitter.Panel min="30%" collapsible size={sizes[1]}>
          {secondPanelContent?.()}
        </Splitter.Panel>
      </Splitter>
    </Card>
  );
};

export default CustomSplitter;
